/** A campaign's lifecycle excludes its entire diagnostic, including saved runs. */
export function isInactiveDiagnosticCampaign(diagnosis = {}, campaign = {}, now = new Date()) {
  const serving = diagnosis.serving || diagnosis.campaign_serving || {};
  const sources = [campaign, serving];
  for (const source of sources) {
    for (const field of ['platform_status', 'status', 'primary_status']) {
      if (['PAUSED', 'ENDED', 'REMOVED'].includes(String(source?.[field] || '').toUpperCase())) return true;
    }
    const reasons = Array.isArray(source?.primary_status_reasons) ? source.primary_status_reasons : [];
    if (reasons.some(reason =>
      ['CAMPAIGN_PAUSED', 'CAMPAIGN_ENDED', 'CAMPAIGN_REMOVED'].includes(String(reason).toUpperCase()))) return true;
  }
  const end = campaign.flight_end_date || campaign.end_date;
  // Date-only flight ends are inclusive. Without an account timezone, wait
  // until the final serving day has finished everywhere (UTC-12).
  const today = new Date(now.getTime() - 12 * 60 * 60 * 1000).toISOString().slice(0, 10);
  if (typeof end === 'string' && /^\d{4}-\d{2}-\d{2}/.test(end)
    && end.slice(0, 10) < today) return true;

  // Older runs may only retain the campaign-level explanation. Do not scan
  // child entities: a paused asset group does not make its campaign paused.
  const summary = diagnosis.health?.summary || diagnosis.campaign_health?.summary || '';
  return /\bcampaign (?:is|has been|has) (?:currently )?(?:paused|ended|removed)\b/i.test(summary);
}

export function excludeInactiveDiagnosticRuns(runs = [], reporting = []) {
  return runs.filter(run => {
    if (run.analysisKind !== 'diagnostic') return true;
    const analysis = run.result?.details?.analysis || {};
    const campaign = reporting.find(row => (row.campaignId || row.id) === run.campaignId)
      || run.result?.analysis_data?.campaign_structure || {};
    return !analysis.skipped && !isInactiveDiagnosticCampaign(run.diagnosis || analysis, campaign);
  });
}
